import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import styles from "./styles";
import { withStyles } from "@material-ui/styles";

import AuthenticationActions, { AuthenticationSelectors } from "../../Redux/AuthenticationRedux";
import { ProfileSelectors } from "../../Redux/ProfileRedux";


class LoadingScreen extends Component {

    // componentDidMount(){
    //     const { authCheck } = this.props;
    //     authCheck();
    // }

    // componentDidUpdate(prevProps){
    //     const { history, tokens, profileDetails, fetching } = this.props;
    //     if(tokens && profileDetails && (fetching !== prevProps.fetching)){
    //         history.push("/Feed");
    //     }
    // }

    render(){
        return (
            <h1>Loading...</h1>
        )
    }
}

const mapStateToProps = state => {
    return {
        tokens: AuthenticationSelectors.getTokens(state),
        profileDetails: ProfileSelectors.getProfile(state),
        fetching: AuthenticationSelectors.getFetching(state)
    }
}

const mapDispatchToProps = dispatch => {
    return {
        authCheck: () => dispatch(AuthenticationActions.authenticationCheckRequest())
    }
}

const withRedux =  connect(
    mapStateToProps,
    mapDispatchToProps
)
export default compose(
    withStyles(styles),
    withRedux
  )(LoadingScreen);